// @flow
import React from 'react'

import FieldForm from '../FieldForm'

// types
import type { FieldFormProps, FieldFormState } from '../FieldForm'
import type { FormValueType } from '../../Types/Values'
import Popover from '../Popover'

type DiscountsFormProps = FieldFormProps & {}

type DiscountsFormPropsState = FieldFormState & {
  blockOpened: boolean,
}

export default class DiscountsForm extends React.Component<DiscountsFormProps, DiscountsFormPropsState> {
  state = {
    associatedFields: {},
    rawContent: {},
    rawSpecification: {},
    specification: {},
    blockOpened: false,
  }

  handleOnValueChange = (key: string, value: FormValueType, pathArray: Array<string>) => {
    this.props.onChangeValue(key, value, pathArray)
  }

  handleToggleBlock = () => {
    this.setState({ blockOpened: !this.state.blockOpened })
  }

  render() {
    const { title, resources, specification, inputHelps } = this.props

    let hasDiscounts = true
    if (resources && resources[specification.name]) {
      hasDiscounts = Object.values(resources[specification.name]).reduce((acc, item) => {
        if (Array.isArray(item) && item.length > 0) {
          acc = true
        }
        return acc
      }, false)
    }
    if (!hasDiscounts) {
      return null
    }

    return (
      <div className='mw-100 discount-form'>
        <hr className='border-0 border-sm-top border-active-object'/>
        <p className='p-0 m-0'>
          <a className='btn btn-link' onClick={this.handleToggleBlock}>
            <strong>{title}</strong>
          </a>
          {inputHelps.content && (
            <>
              &nbsp;
              <Popover
                content={inputHelps.content}
                id={`discount-title-${specification.name}`}
                title={inputHelps.title}
              />
            </>
          )}
        </p>
        <FieldForm
          {...this.props}
          onChangeValue={this.handleOnValueChange}
          showBlockTitle={false}
        />
      </div>
    )
  }
}
